<template>
    <div class="auth-shell">
        <div class="bg-mesh" />

        <div class="auth-shell__container">
            <glass-panel
                radius="lg"
                class="auth-shell__card"
            >
                <!-- Coluna visual (imagem ou ilustração custom) -->
                <div
                    v-if="image || $slots.visual"
                    class="auth-shell__visual"
                >
                    <slot name="visual">
                        <img
                            :src="image"
                            :alt="imageAlt"
                            class="auth-shell__image"
                        >
                    </slot>
                    <div class="auth-shell__visual-overlay" />
                    <div
                        v-if="$slots.visualContent"
                        class="auth-shell__visual-content"
                    >
                        <slot name="visualContent" />
                    </div>
                </div>

                <!-- Coluna do formulário -->
                <div class="auth-shell__form-wrap">
                    <div class="auth-shell__brand">
                        <div class="auth-shell__brand-icon">
                            <v-img
                                src="@/assets/logo-mini.png"
                                contain
                                width="22"
                                height="22"
                            />
                        </div>
                        <div class="d-flex flex-column" style="min-width:0">
                            <span class="auth-shell__brand-title">Future Marketing</span>
                            <span class="eyebrow">Sites para Saúde</span>
                        </div>
                    </div>

                    <div class="auth-shell__form">
                        <slot />
                    </div>
                </div>
            </glass-panel>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AuthShell',
    props: {
        image: {
            type: String,
            default: null,
        },
        imageAlt: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
.auth-shell {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    overflow: hidden;
}

.auth-shell__container {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1100px;
}

.auth-shell__card {
    display: grid;
    grid-template-columns: 1fr;
    overflow: hidden;
    padding: 0;
    min-height: 540px;
}

.auth-shell__visual {
    position: relative;
    display: none;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dim) 100%);
    overflow: hidden;
}

.auth-shell__image {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.auth-shell__visual-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(45, 0, 102, 0.0) 0%, rgba(45, 0, 102, 0.4) 100%);
}

.auth-shell__visual-content {
    position: absolute;
    inset: 0;
    padding: 32px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    color: #fff;
    z-index: 1;
}

.auth-shell__form-wrap {
    display: flex;
    flex-direction: column;
    padding: 40px 32px;
    min-width: 0;
}

.auth-shell__brand {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 32px;
}

.auth-shell__brand-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dim) 100%);
    box-shadow: var(--shadow-pulse);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.auth-shell__brand-title {
    font-family: var(--font-display);
    font-weight: 900;
    font-size: 1rem;
    color: var(--color-on-surface);
    line-height: 1.1;
    letter-spacing: -0.01em;
}

.auth-shell__form {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

@media (min-width: 768px) {
    .auth-shell__card {
        grid-template-columns: 1fr 1fr;
        min-height: 600px;
    }
    .auth-shell__visual {
        display: block;
    }
    .auth-shell__form-wrap {
        padding: 56px 48px;
    }
}
</style>
